import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M6.38379 8.53027C6.38379 9.96907 7.55745 11.1402 8.99937 11.1402C10.4413 11.1402 11.615 9.96907 11.615 8.53027C11.615 7.09147 10.4413 5.92035 8.99937 5.92035C7.55745 5.92035 6.38379 7.09147 6.38379 8.53027ZM7.88272 8.53027C7.88272 7.91627 8.38404 7.41603 8.99937 7.41603C9.61471 7.41603 10.116 7.9146 10.116 8.53027C10.116 9.14427 9.61471 9.6445 8.99937 9.6445C8.38404 9.6445 7.88272 9.14427 7.88272 8.53027Z",
      fill: "#747577"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.03318 9.98422C3.30744 11.5502 5.90625 14.1751 8.99969 14.1751C12.0948 14.1751 14.6919 11.5502 15.9662 9.98422C16.6771 9.10922 16.6788 7.84107 15.9662 6.96608C14.6919 5.40012 12.0931 2.77515 8.99969 2.77515C5.90625 2.77515 3.30744 5.40012 2.03318 6.96608C1.32227 7.84107 1.32227 9.10922 2.03318 9.98422ZM3.19678 7.91134C4.30337 6.55117 6.52829 4.2725 8.99969 4.2725C11.4728 4.2725 13.6977 6.55117 14.8026 7.91134C15.0608 8.22754 15.0608 8.72443 14.8026 9.0423C13.696 10.4008 11.4728 12.6795 8.99969 12.6795C6.52662 12.6795 4.30337 10.4008 3.19678 9.0423C2.93857 8.7261 2.93857 8.22921 3.19678 7.91134Z",
      fill: "#747577"
    }, null, -1)
  ]))]))
}
export default { render: render }